import React from 'react'
import logo from '../../assets/images/logo.png'
import { Button } from '../../components'
import { useNavigate } from 'react-router-dom'

export default function ReceivedRequest(): React.ReactElement {
    const navigate = useNavigate()

    return (
        <div id="received_request">
            <div className="received__backgound">
                <div className="received__content">
                    <div className="received__images">
                        <img src={logo} alt="Logo CNA construtora" className="received__logo" />
                        <div className="fino-acabamento-box">
                            <p className="fino-acabamento-logo">Fino</p>
                            <p className="fino-acabamento-logo">Acabamento</p>
                        </div>
                    </div>
                    <h4>Recebemos seu Cadastro!</h4>
                    <p>Em breve daremos um retorno referente à aprovação do seu cadastro para você acessar a nossa área do cliente</p>
                    <div className="box_button">
                        <Button placeholder="Voltar" onClick={() => navigate('/login')} />
                    </div>
                </div>
            </div>
        </div>
    )
}
